export default "__VITE_ASSET__cdef96cb__"